module.exports = __webpack_public_path__ + "static/media/ArrowDown.c54b1dc3.svg";